import React, { useMemo, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';

// Estilos para el área de dropzone
const baseStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  transition: 'border .3s ease-in-out',
};

const activeStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

// Componente UploadVoucher
const UploadVoucher = ({ showOverlay, setShowOverlay, handleVoucherSubmit, isUploadingVoucher }) => {

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    multiple: false,
    disabled: isUploadingVoucher,
    onDrop: (files) => {
      if (files.length > 0 && !isUploadingVoucher) handleVoucherSubmit(files);
    },
    accept: 'image/jpeg, image/png, image/jpg, image/webp',
    maxSize: 10 * 1024 * 1024,
  });

  
  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  useEffect(() => {
    if (!showOverlay) {
      acceptedFiles.length = 0;
    }
  }, [showOverlay]);

  return (
    <div className="cart-container">
      
      {showOverlay === 'block' && (
        <div id="debt" className="search-overlay has-debt"
          style={{ display: showOverlay }}>
          <div>
            <span
              className="closebtn"
              onClick={() => setShowOverlay(false)}
              title="Cerrar Overlay"
            >
              ×
            </span>
            <div className="overlay-content options-overlay-content">
              <div className="container">
                <div className="row" style={{ display: 'block' }}>
                  <div {...getRootProps({ style })}>
                    <input {...getInputProps()} />
                    <p style={{ color: '#000' }}>
                      {isUploadingVoucher
                        ? 'Subiendo...'
                        : 'Arrastra y suelta algunos archivos aquí, o haz clic para seleccionarlos.'}
                    </p>
                  </div>
                  {fileRejections.length > 0 && (
                    <p style={{ color: '#ff1744', marginTop: '8px', textAlign: 'center' }}>
                      {fileRejections[0].errors[0].code === 'file-too-large'
                        ? 'El archivo supera el límite de 10 MB.'
                        : 'Formato no válido. Usa JPG o PNG.'}
                    </p>
                  )}
                  <aside>
                    <h4>Archivos</h4>
                    <ul>{files}</ul>
                  </aside>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadVoucher;
